import { buildSrc } from '@/integrations/image-kit';
import { Avatar, AvatarImage } from '@/shared/components/ui/avatar';
import { Spinner } from '@/shared/components/ui/spinner';
import { cn } from '@/shared/utils/cn';

const mascotImageUrl = buildSrc({
  src: '/duos-storage/loading-duo.png',
  transformation: [{ width: 600, height: 600, dpr: 2 }],
});

export function SignInLoadingScreen() {
  return (
    <div className="p-safe flex h-full w-full flex-col bg-linear-to-b from-[#28135C] via-[#170919] to-black">
      <div
        className={cn(
          'flex h-full w-full flex-col items-center justify-center',
          'p-4 text-center',
        )}
      >
        <Avatar className="mb-8 size-75">
          <AvatarImage src={mascotImageUrl} alt="Duo mascot" />
        </Avatar>

        <h1
          className={cn(
            'mb-4 font-black tracking-tight text-white',
            'text-2xl leading-tight md:text-3xl',
          )}
        >
          Welcome to Duos!
        </h1>

        <p className="text-cold-300 mb-4 text-sm font-medium">
          Processing your Riot account...
        </p>

        <Spinner className="text-cardpink-300 size-8" />
      </div>
    </div>
  );
}
